<template>
  <fragment>
    <!-- title -->
    <v-card-title>
      {{ title }} | {{ typeof(visitDate) === 'String' ? visitDate : this.$date(visitDate).format('MM/DD/YYYY') }}
      <v-spacer></v-spacer>
      <patient-name
        :patient="patient"
      ></patient-name>
    </v-card-title>

    <!-- patient info -->
    <v-card-title class="v-card__subtitle pt-2 pb-0">
      <div
        v-if="visitType"
        :class="{
          'visitTypeNew': visitType === 'New',
          'visitTypeFU': visitType !== 'New',
          'text-uppercase': true
        }"
      >
        {{ visitType }}
      </div>
      <slot v-else></slot>

      <v-spacer></v-spacer>

      <div>
        <div>
          <patient-info
            class="align-self-start"
            :patient="patient"
          ></patient-info>
        </div>
      </div>
    </v-card-title>

    <alert
      v-if="notice"
      class="ma-5 text-uppercase"
      color="error"
    >
      {{ notice }}
    </alert>

    <patient-insurance-banner
      :patient-id="patient.id"
    />
  </fragment>
</template>

<script>
import '@/components/patients/primitives'
import PatientInsuranceBanner from '@/components/elements/PatientInsuranceBanner.vue'

export default {
  components: { PatientInsuranceBanner },
  props: {
    title: {
      type: String,
      default: null,
    },
    patient: {
      type: Object,
      default: null,
    },
    visitType: {
      type: String,
      default: null,
    },
    visitDate: {
      type: [Date, String],
      default: null,
    },
  },
  computed: {
    notice() {
      return this.patient.is_deceased ? `Patient Deceased ${this.$date(this.patient.date_deceased).format('MM/DD/YYYY')}` : false
    },
  },
}
</script>

<style lang="scss">
.not-bold {
  font-weight: normal !important;
}

.visitTypeNew,
.visitTypeFU {
  color: white;
  padding: 10px;
  border-radius: 5px;
  box-sizing: border-box;
  width: 120px;
  text-align: center;
}

.visitTypeNew {
  background-color: green;
}

.visitTypeFU {
  background-color: red;
}
</style>
